import React from "react"
import FieldProto from "../proto/field-proto";

export enum FieldPickerType {
    DEFAULT = 'default',
    CIRCLE  = 'circle'
}

export enum FieldPickerSize {
    DEFAULT     = 'default',
    SIZE_30     = '30'
}

export type FieldPickerProps = {
    type?           : FieldPickerType
    size?           : FieldPickerSize
    field           : FieldProto
    model           : any
    disabled?       : boolean
    configOptions?  : any
    onChange?       : func // onChangeCallback
    className?      : string
    options?        : any
};

export default function FieldPicker(props:FieldPickerProps):any {
    return <props.field.renderComponents.picker {...props} />
}